import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Input, Select, Button, Space } from 'antd';
import styles from './index.module.scss';

const { Option } = Select;

const NodeEditor = ({ node, lanes, laneOrder, onSave, onDelete, onClose }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState(node);

  useEffect(() => {
    setFormData(node);
  }, [node]);

  const handleSave = () => {
    if (!formData.label.trim()) {
      return;
    }
    onSave(formData);
  };

  return (
    <Modal
      title={t('tools.timeline.editNode')}
      open={true}
      onCancel={onClose}
      footer={[
        <Button key="delete" danger onClick={() => onDelete(node.id)}>
          {t('tools.timeline.delete')}
        </Button>,
        <Button key="cancel" onClick={onClose}>
          {t('tools.timeline.cancel')}
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          {t('tools.timeline.save')}
        </Button>,
      ]}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <div>
          <label className={styles.label}>{t('tools.timeline.nodeName')}</label>
          <Input
            value={formData.label}
            onChange={(e) => setFormData({ ...formData, label: e.target.value })}
          />
        </div>
        <div>
          <label className={styles.label}>{t('tools.timeline.date')}</label>
          <Input
            type="date"
            value={formData.date}
            onChange={(e) => setFormData({ ...formData, date: e.target.value })}
          />
        </div>
        <div>
          <label className={styles.label}>{t('tools.timeline.lane')}</label>
          <Select
            value={formData.cat}
            onChange={(cat) => setFormData({ ...formData, cat })}
            style={{ width: '100%' }}
          >
            {laneOrder.map((key) => (
              <Option key={key} value={key}>
                {lanes[key]?.name}
              </Option>
            ))}
          </Select>
        </div>
        <div>
          <label className={styles.label}>{t('tools.timeline.priority')}</label>
          <Select
            value={formData.priority}
            onChange={(priority) => setFormData({ ...formData, priority })}
            style={{ width: '100%' }}
          >
            <Option value="P0">P0 — {t('tools.timeline.p0')}</Option>
            <Option value="P1">P1 — {t('tools.timeline.p1')}</Option>
            <Option value="P2">P2 — {t('tools.timeline.p2')}</Option>
            <Option value="P3">P3 — {t('tools.timeline.p3')}</Option>
          </Select>
        </div>
        <div>
          <label className={styles.label}>{t('tools.timeline.status')}</label>
          <Select
            value={formData.status || 'todo'}
            onChange={(status) => setFormData({ ...formData, status })}
            style={{ width: '100%' }}
          >
            <Option value="todo">{t('tools.timeline.statusTodo')}</Option>
            <Option value="doing">{t('tools.timeline.statusDoing')}</Option>
            <Option value="done">{t('tools.timeline.statusDone')}</Option>
          </Select>
        </div>
      </Space>
    </Modal>
  );
};

export default NodeEditor;
